import { Modal, Separator, Grid, Button } from '@design-systems/canvas-ui'
import { getRfiTagValues } from '../../../common/common'

const RfiFormConfirmationModal = (props) => {
  /**
   * Get message content for RFI confirmation
   * @returns
   */
  const getMessage = () => {
    return props.isSaveAndCloseClicked
      ? getRfiTagValues('headingMessages')?.saveAndCloseRFIMessage.replace(
          'DESTINATION_PAGE',
          'Supplier Management',
        )
      : getRfiTagValues('headingMessages')?.submitRFIMessage.replace(
          'DESTINATION_PAGE',
          'Supplier Management',
        )
  }

  return (
    <Modal
      id="modal-rfi-confirm"
      headingText="Confirm"
      isOpen={props.isVisible}
      onClose={() => props.closeConfirmation()}
      className="lcm-rfi-confirm-modal"
    >
      <p
        id="modal-header-text-rfi-confirm"
        data-testid="modal-header-text-rfi-confirm-test"
        dangerouslySetInnerHTML={{
          __html: [getMessage()],
        }}
        className="lcm-rfi-confirm__message hc8-fs-150 hc8-lh-body hc8-mb-none hc8-ph-6x hc8-pv-4x"
      />
      <Separator className="hc8-mv-none" />

      {/* Action Buttons */}
      <Grid.Container
        id="container-rfi-form-actions"
        className="lcm-modal-actions lcm-rfi-confirm__actions hc8-ph-6x hc8-pv-4x"
      >
        {props.isSaveAndCloseClicked ? (
          //[SAVE & CLOSE SUBMISSION ACTION]
          <>
            <Button
              id="button-rfi-confirm-cancel"
              data-testid="button-rfi-confirm-cancel"
              className="popup-button hc8-mr-3x"
              variant="secondary"
              size="md"
              onClick={() => {
                props.rfiSaveAndContinueActionClickHandler(false)
              }}
            >
              Cancel
            </Button>
            <Button
              id="button-rfi-confirm-ok"
              data-testid="button-rfi-confirm-ok"
              className="popup-button"
              variant="primary"
              size="md"
              onClick={() => {
                props.rfiSaveAndContinueActionClickHandler(true)
              }}
            >
              OK
            </Button>
          </>
        ) : (
          //[FINAL SUBMIT ACTION]
          <>
            <Button
              id="button-rfi-confirm-back"
              data-testid="button-rfi-confirm-back"
              className="popup-button hc8-mr-3x"
              variant="secondary"
              size="md"
              onClick={() => {
                props.rfiFinalConfirmationActionClickHandler(true)
              }}
            >
              Back
            </Button>
            <Button
              id="button-rfi-confirm-submit"
              data-testid="button-rfi-confirm-submit"
              className="popup-button"
              variant="primary"
              size="md"
              onClick={() => {
                props.rfiFinalConfirmationActionClickHandler(false)
              }}
            >
              Submit
            </Button>
          </>
        )}
      </Grid.Container>
    </Modal>
  )
}

export default RfiFormConfirmationModal
